// Local dates and clock times in a place's own time zone, the same in the app and the alerts Worker. Days are
// counted on the calendar, never as 24 hours (the day the clocks go back lasts 25), and a clock time is found
// exactly, also where the zone is a quarter or half an hour off whole hours (Kathmandu, India).

const fmts = new Map<string, Intl.DateTimeFormat>();

/** The local date (YYYY-MM-DD) at `tz`, and the hour and minute its clocks show. */
export function clockAt(t: number, tz: string): { date: string; hour: number; minute: number } {
  let f = fmts.get(tz);
  if (!f) fmts.set(tz, (f = new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: tz })));
  const p: Record<string, string> = {};
  for (const x of f.formatToParts(t)) p[x.type] = x.value;
  return { date: `${p.year}-${p.month}-${p.day}`, hour: Number(p.hour), minute: Number(p.minute) };
}

/** The date `n` calendar days after `date` (YYYY-MM-DD; `n` may be negative). */
export const addDays = (date: string, n: number) => new Date(Date.parse(`${date}T12:00:00Z`) + n * 86400e3).toISOString().slice(0, 10);

/** The local date at `tz` for days that start at `startHour`: before then it is still the day before. */
export function dayFrom(t: number, tz: string, startHour: number): string {
  const c = clockAt(t, tz);
  return c.hour < startHour ? addDays(c.date, -1) : c.date;
}

/** The moment the clocks at `tz` show `hour`:00 on `date` (YYYY-MM-DD). */
export function wallTime(date: string, tz: string, hour: number): number {
  const [y, m, d] = date.split('-').map(Number);
  const wall = Date.UTC(y, m - 1, d, hour);
  let at = wall;
  // Two passes settle the zone's offset, also on the day the clocks change.
  for (let i = 0; i < 2; i++) {
    const c = clockAt(at, tz);
    const [yy, mm, dd] = c.date.split('-').map(Number);
    at += wall - Date.UTC(yy, mm - 1, dd, c.hour, c.minute);
  }
  return at;
}
